import { type InternalAxiosRequestConfig } from "axios";

import { $allByFundId } from "@vega-api/custom/stores/allByFundId.store";
import { $selectedInvestor } from "@vega-api/custom/stores/investors.store";
import { $organizationId } from "@vega-api/custom/stores/organisations.store";
import { $requestId } from "@vega-api/custom/stores/request.store";
import { getCurrentPortalType } from "@vega-api/extended/auth/redirectUtils";
import { isGPPortal } from "@vega-core/utils/global";
import { isTruthy } from "@vega-core/utils/isTruthy";

import { calculateUrlLength } from "./utils/calculateUrlLength";

export const headersInterceptor = (config: InternalAxiosRequestConfig) => {
  const organisationId = $organizationId.get();
  const selectedUser = $selectedInvestor.get();
  const allByFundId = $allByFundId.get();
  const requestId = $requestId.get();

  if (
    isTruthy(organisationId) &&
    !isTruthy(config.headers["Limited-Partner-Id"])
  ) {
    config.headers["Limited-Partner-Id"] = organisationId;
  }

  if (
    isTruthy(selectedUser?.id) &&
    !isTruthy(config.headers["Selected-User-Id"])
  ) {
    config.headers["Selected-User-Id"] = selectedUser.id;
  }

  if (isTruthy(allByFundId)) {
    config.headers["Fund-Id"] = allByFundId;
  }

  if (isTruthy(requestId)) {
    config.headers["Request-Id"] = requestId;
  }

  config.headers["Is-GP-Portal"] = isGPPortal ? "true" : "false";
  config.headers["FE-Portal-Type"] = getCurrentPortalType();

  if (config.method?.toLowerCase() === "get") {
    // creates a header with the length of the request URL
    // this is used to track the length of the request URL in Grafana
    // if the length exceeds 8KB, an error is pushed to Grafana
    config.headers["X-Request-Url-Length"] = String(calculateUrlLength(config));
  }

  return config;
};
